import React from 'react';
import Button from 'src/app/atoms/Button/Button';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import HeadingAndSupportingTextWithActions from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';

const CommunityDesignTextBlock = (): JSX.Element => (
  <HeadingAndSupportingTextWithActions
    direction='column'
    justify='flex-start'
    align='flex-start'
    subHeading={{
      type: 'paragraph',
      size: 'md',
      text: 'Strategy Meets Software',
      fontWeight: 'font-weight-semibold',
      color: 'text-brand-secondary',
    }}
    heading={{
      type: 'heading',
      size: 'xl',
      text: 'Community Design™',
      letterSpacing: -1,
    }}
    supportingText={{
      type: 'paragraph',
      size: 'lg',
      color: 'text-tertiary',
      children: (
        <Stack
          direction='column'
          gap='spacing-lg'
          as='span'
        >
          <Typography
            as='span'
            text='The framework behind $500M and everything we build.'
          />
          <Typography
            as='span'
            text='Your Ideal Member. Their Best Year Ever. Monthly Themes. Weekly Events. Daily Questions — now available as an AI Cohost tuned to your community and goals.'
          />
        </Stack>
      ),
    }}
    gap='spacing-2xl'
    subHeadingGap='spacing-lg'
    actions={
      <Stack
        maxWidth='width-fit-content'
        marginTop='spacing-4xl'
      >
        <Button
          variant='primary'
          size='xl'
          href='https://cohost.mn.co/?plan=free-trial'
        >
          Try Mighty for Free
        </Button>
      </Stack>
    }
  />
);

export default CommunityDesignTextBlock;
